import { FC, ReactNode, useEffect } from 'react';
import { Locale } from 'translations';
import { TranslationContextProvider, useTranslationContext } from '../contexts/translationContext';

const LearningPanelComponents: FC<LearningPanelComponentsProviderProps> = (
    props: LearningPanelComponentsProviderProps
) => {
    const { setTranslate, setLocale } = useTranslationContext();

    useEffect(() => {
        props.translate && setTranslate(() => props.translate);
    }, [props.translate]);

    useEffect(() => {
        props.locale && setLocale(props.locale);
    }, [props.locale]);

    return <>{props.children}</>;
};

const LearningPanelComponentsProvider: FC<LearningPanelComponentsProviderProps> = (
    props: LearningPanelComponentsProviderProps
) => {
    return (
        <TranslationContextProvider>
            <LearningPanelComponents translate={props.translate} locale={props.locale}>
                {props.children}
            </LearningPanelComponents>
        </TranslationContextProvider>
    );
};

interface LearningPanelComponentsProviderProps {
    translate: Function;
    locale?: keyof typeof Locale;
    children: ReactNode;
}

export default LearningPanelComponentsProvider;
